export default __webpack_public_path__ + "static/media/react.50f9ae03.svg";